import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.timers.js";
// import ButtonBasic from '@/components/form/ButtonBasic.vue';
// import ToggleComponent from '@/components/form/ToggleComponent.vue';
//   import { ref } from 'vue';
// 

export default {
  name: 'IntroPersonality',
  components: {
    // ButtonBasic,
    // ToggleComponent,
  },
  mounted: function mounted() {
    console.log('<<<<<<<<< IntroPersonality mounted >>>>>>>>>');
    if (this.$store.state.selectedGalleryAvatar.isFemale) {
      this.actualProfileList = this.femaleProfile;
    } else {
      this.actualProfileList = this.maleProfile;
    }
  },
  methods: {
    readThisProfile: function readThisProfile(profile) {
      var _this = this;
      this.profileContentToRead = profile.profile;
      this.profileLabelToRead = profile.label;
      setTimeout(function () {
        _this.showReadingPanel = true;
      }, 250);
    },
    backButton: function backButton() {
      this.$store.commit('stopIntroPage', 'Personality');
      this.$store.commit('startIntroPage', 'Voice');
    },
    playSample: function playSample(filename) {
      console.log('play sample', filename);
    },
    acceptPersonality: function acceptPersonality() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!_this2.$store.state.customerSelectedProfile || _this2.$store.state.customerSelectedProfile == '')) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return _this2.$store.dispatch("saveProfileToDB");
            case 4:
              //if we are just saving a single setting 
              if (_this2.$store.state.singleIntroSave === true || _this2.$store.state.singleIntroSave === 'true') {
                _this2.$store.commit('updatePreventIntroExperience', false);
                // this.$store.dispatch("saveProfileToDB", 'profile');
                _this2.$store.commit('updateSingleIntroSave', false);
                _this2.$store.commit('stopIntroPage', 'Personality');
              } else {
                //saving at the end so keep going (standard flow)
                _this2.$store.commit('stopIntroPage', 'Personality');
                _this2.$store.commit('startIntroPage', 'Interests');
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    selectPersonality: function selectPersonality(profileID) {
      this.actualProfileList.forEach(function (profile) {
        profile.selected = false;
        console.log('profile', profile);
      });

      // set selected voice to true
      this.actualProfileList[profileID].selected = true;
      this.$store.commit('updateCustomerSelectedProfile', this.actualProfileList[profileID].label);
    }
  },
  setup: function setup() {},
  data: function data() {
    return {
      profileContentToRead: '',
      profileLabelToRead: '',
      actualProfileList: [],
      showReadingPanel: false,
      femaleProfile: [{
        label: 'Submissive',
        profile: "She will submit to you and obey your commands. Very Obedient",
        selected: false,
        XXX: true
      }, {
        label: 'Dominating',
        profile: "Typically very forward and aggressive. She's not afraid to take control and will often be the one to initiate. If you try to boss her around she's likely going to put you in your place.",
        selected: false,
        XXX: true
      }, {
        label: 'Friendly',
        profile: "Typically, this profile is very friendly and easy to get along with. Don't be surprised if she's a little flirty. ",
        selected: false,
        XXX: false
      }, {
        label: 'Punisher',
        profile: "Typically, this profile tends to be very rude and aggressive and likes to have a lot of fun but also likes to talk shit but is just as capable of talking dirty to you.",
        selected: false,
        XXX: true
      }],
      maleProfile: [{
        label: 'Dominant',
        profile: 'Will dominate you and have his way you with, making you obey.',
        selected: false,
        XXX: true
      }, {
        label: 'Submissive',
        profile: 'Will submit and obey to your every command and desire.',
        selected: false,
        XXX: true
      }, {
        label: 'Romantic',
        profile: 'With a heart full of passion and a knack for grand gestures, this profile is ideal for those who yearn for deep emotional connections and timeless love stories.',
        selected: false,
        XXX: true
      }, {
        label: 'Friendly',
        profile: 'Deep thinker and lover of profound conversations, this profile is perfect for those who seek intellectual and meaningful discussions.',
        selected: false,
        XXX: false
      }]
    };
  }
};